import { PropsWithChildren, ReactNode } from 'react';

import {
  Modal as ChakraModal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalHeaderProps,
  ModalOverlay,
  ModalOverlayProps,
  ModalProps as ChakraModalProps,
} from '@chakra-ui/react';

export type ModalProps = PropsWithChildren<
  ChakraModalProps & {
    title: ReactNode | string;
    footerButtons?: ReactNode;
    modalOverlayProps?: ModalOverlayProps;
    showCloseButton?: boolean;
    modalHeaderProps?: ModalHeaderProps;
  }
>;

export function Modal({
  title,
  footerButtons,
  modalOverlayProps,
  children,
  showCloseButton = true,
  modalHeaderProps,
  ...rest
}: ModalProps) {
  return (
    <ChakraModal {...rest}>
      <ModalOverlay {...modalOverlayProps} />
      <ModalContent>
        <ModalHeader {...modalHeaderProps}>{title}</ModalHeader>
        {showCloseButton && <ModalCloseButton />}
        <ModalBody>{children}</ModalBody>
        {footerButtons && <ModalFooter gap={6}>{footerButtons}</ModalFooter>}
      </ModalContent>
    </ChakraModal>
  );
}
